import React from 'react';

const IconHackerRank = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-hackerrank"
  >
    <title>HackerRank</title>
    {/* <!-- Hexagon background (usually green in colored version) --> */}
    <path d="M12 2L4 7v10l8 5 8-5V7l-8-5z"></path>
    {/* <!-- H letter --> */}
    <path d="M8.5 8v8M15.5 8v8M8.5 12h7"></path>
  </svg>
);

export default IconHackerRank;
